module.exports = __webpack_public_path__ + "media/application/images/svgs/upload-206ddfd3063106fc83c4f0f06aff6b06.svg";